// extracted by mini-css-extract-plugin
export default {"wrap":"AppLoading_wrap__VWnNZ","spinner":"AppLoading_spinner__7Qw3x"};